import React from 'react';
import { AppPlatform, AppStoreType, Automation } from '../../types';
import Select from 'antd/lib/select';
import { StepGraphStep } from '@/types/workflow';
import { InlineStepConfigDescription } from '@/components/common/InlineStepConfigDescription';
import { compact } from 'lodash';

interface StepConfigSelectorProps {
    value: string;
    sameTypeAutomations: Automation[];
    stepGraphStepsMap: Record<string, StepGraphStep>;
    platform: AppPlatform;
    appStoreType: AppStoreType;
    onChange?: (automationId: string) => void;
    isWorkflowsCIStepEnabled: boolean;
}

export const StepConfigSelector: React.FC<StepConfigSelectorProps> = ({
    value,
    sameTypeAutomations,
    stepGraphStepsMap,
    platform,
    appStoreType,
    onChange,
    isWorkflowsCIStepEnabled,
}) => {
    return (
        <Select
            value={value}
            size={'large'}
            style={{ width: '100%' }}
            allowClear={false}
            options={compact(
                sameTypeAutomations.map((automation) => {
                    const stepGraphStep = stepGraphStepsMap[automation.stepConfigId];
                    if (!stepGraphStep) {
                        return null;
                    }

                    return {
                        value: automation.id,
                        label: (
                            <InlineStepConfigDescription
                                stepGraphStep={stepGraphStep}
                                platform={platform}
                                appStoreType={appStoreType}
                                isWorkflowsCIStepEnabled={isWorkflowsCIStepEnabled}
                            />
                        ),
                    };
                }),
            )}
            onChange={onChange}
        />
    );
};
